import { memo, RouterProvider, createBrowserRouter, Route, createRoutesFromElements } from 'components/lib/react-npm';
import { privateRouteList, publicRouteList } from './data';
import PrivateRouter from './PrivateRouter';
import PublicRouter from './PublicRouter';

function RoutesComponent() {

    const render = () => {

        return (
            <>

                {/* Public Route List  */}
                {publicRouteList.map(({ title, path, element: Element, restricted, ...rest }) => (
                    <Route key={title} element={<PublicRouter title={title} {...rest} />}>
                        <Route path={path} element={<Element />} />
                    </Route>
                ))}

                {/* Private Route List */}
                {privateRouteList.map(({ title, path, allowedRoles, element: Element, ...rest }) => (
                    <Route key={title} element={<PrivateRouter allowedRoles={allowedRoles} title={title} {...rest} />}>
                        <Route path={path} element={<Element />} />
                    </Route>
                ))}

                <Route path={'/*'} element={<h1>Page not found 404</h1>} />

            </>
        )
    }

    const router = createBrowserRouter(createRoutesFromElements(render()));

    return <RouterProvider router={router} />

}

export default memo(RoutesComponent)